import _ from 'lodash';
import { Types } from '../actions/intelligentImportActions';

const defaultImportState = {
  currentJob: null,
  jobs: [],
  stagingItems: [],
  filteredRows: [],
  factorMatches: [],
  enrichmentCandidates: [],
  orgDateFormat: null,
  aiQuota: null,
  qualityScore: null,
  ledgerMappings: [],
  polling: false,
  loading: {},
  error: null,
};

const intelligentImportReducers = (state, action) => {
  const newState = _.cloneDeep(state);

  switch (action.type) {
    case Types.IMPORT_SET_CURRENT_JOB:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        currentJob: action.payload
          ? { ...(newState.intelligentImport?.currentJob || {}), ...action.payload }
          : null,
      };
      return newState;

    case Types.IMPORT_SET_JOBS:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        jobs: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_STAGING:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        stagingItems: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_FILTERED_ROWS:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        filteredRows: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_MATCHES:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        factorMatches: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_ENRICHMENT:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        enrichmentCandidates: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_POLLING:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        polling: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_LOADING: {
      const { section, value } = action.payload;
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        loading: {
          ...(newState.intelligentImport?.loading || {}),
          [section]: value,
        },
      };
      return newState;
    }

    case Types.IMPORT_SET_ERROR:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        error: action.payload,
      };
      return newState;

    case Types.IMPORT_CLEAR_JOB:
      newState.intelligentImport = { ...defaultImportState };
      return newState;

    case Types.IMPORT_SET_ORG_DATE_FORMAT:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        orgDateFormat: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_AI_QUOTA:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        aiQuota: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_QUALITY_SCORE:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        qualityScore: action.payload,
      };
      return newState;

    case Types.IMPORT_SET_LEDGER_MAPPINGS:
      newState.intelligentImport = {
        ...(newState.intelligentImport || defaultImportState),
        ledgerMappings: action.payload,
      };
      return newState;

    default:
      return state;
  }
};

export default intelligentImportReducers;
